// extracted by mini-css-extract-plugin
module.exports = {"BannersAsProductTile__wrapper":"BannersAsProductTile_BannersAsProductTile__wrapper__jmU2u","BannersAsProductTile__slide":"BannersAsProductTile_BannersAsProductTile__slide__jQIey"};